// services/pos.js
import axiosInstance from './axiosInstance';

const POS_API_URL = '/pos';

const posService = {
  async getPermissions(idempresa) {
    try {
      const response = await axiosInstance.get(`${POS_API_URL}/permissions/get.php?idempresa=${idempresa}`);
      return response.data;
    } catch (error) {
      console.error(error);
      return {};
    }
  }
};

export default posService;
